import { cva } from 'class-variance-authority';

export const variant = {
  'numbers-xl':
    'eye:font-semibold eye:text-42 eye:leading-60 eye:tracking-0 eye:md:text-60',
  'numbers-l':
    'eye:font-semibold eye:text-26 eye:leading-60 eye:tracking-0 eye:md:text-42',
  'headline-xl':
    'eye:font-semibold eye:text-26 eye:leading-32 eye:tracking-0 eye:md:text-42 eye:md:leading-56',
  'headline-l':
    'eye:font-semibold eye:text-26 eye:leading-32 eye:tracking-0 eye:md:text-34 eye:md:leading-48',
  'headline-m':
    'eye:font-semibold eye:text-22 eye:leading-32 eye:tracking-0 eye:md:text-26 eye:md:leading-48',
  'headline-s':
    'eye:font-semibold eye:text-20 eye:leading-30 eye:tracking-0 eye:md:text-24 eye:md:leading-30',
  'headline-xs':
    'eye:font-semibold eye:text-16 eye:leading-22 eye:tracking-0 eye:md:text-18 eye:md:leading-24',
  'body-l-highlight':
    'eye:font-medium eye:text-16 eye:leading-22 eye:tracking-0 eye:md:text-18 eye:md:leading-24',
  'body-l':
    'eye:font-regular eye:text-16 eye:leading-22 eye:tracking-0 eye:md:text-18 eye:md:leading-24',
  'body-m-highlight':
    'eye:font-medium eye:text-14 eye:leading-22 eye:tracking-0 eye:md:text-16 eye:md:leading-24',
  'body-m':
    'eye:font-regular eye:text-14 eye:leading-22 eye:tracking-0 eye:md:text-16 eye:md:leading-24',
  'body-s-highlight':
    'eye:font-semibold eye:text-14 eye:leading-22 eye:tracking-1 eye:md:text-14 eye:md:leading-24',
  'body-s':
    'eye:font-regular eye:text-14 eye:leading-22 eye:tracking-0 eye:md:text-14 eye:md:leading-24',
  'body-xs': 'eye:font-medium eye:text-9 eye:leading-16 eye:tracking-0 ',
  button:
    'eye:font-medium eye:text-14 eye:leading-22 eye:tracking-0 eye:md:text-16 eye:md:leading-24',
  tag: 'eye:font-medium eye:text-12 eye:leading-22 eye:tracking-0 eye:md:leading-24',
};

// Must update JSDoc comments for TypographyProps when changing this mapping
export const tagVariant = {
  h1: 'headline-xl',
  h2: 'headline-l',
  h3: 'headline-m',
  h4: 'headline-s',
  h5: 'headline-xs',
} as const satisfies Record<string, keyof typeof variant>;

export const typographyVariants = cva('eye:[&]:text-black', {
  variants: {
    variant: variant,
  },
  defaultVariants: {
    variant: 'numbers-xl',
  },
});
